import { Controller } from "@hotwired/stimulus";

let badVals = ["", "", null, 0, "0"];
let notInUseFields = [];

export default class extends Controller {
    static targets = ["form"];

    connect() {
        console.log('Document Filters controller connected');
    }

    submit(event) {
        // Ensures web components are re-render
        requestAnimationFrame(() => {

        let data = new FormData(this.formTarget);
        for (let [key, value] of data) {
            data.set(key, data.getAll(key))

            console.log("Key: "+key+" Value: "+value);
        }


            // Disables all inputs not filled in. Submits the form so only submitted fields are sent, then re-enables all fields.

            // Iterates all form fields, sets disabled attribute if value is a bad value
            this.formTarget.querySelectorAll("input, select, wa-select, wa-checkbox, wa-switch, wa-radio-group, textarea").forEach((el) => {
                if (!el.hasAttribute('disabled')) {
                    if (badVals.includes(el.value)) {
                        // If field is not used
                        notInUseFields.push(el);
                        el.setAttribute('disabled', true);
                    }
                }
            });

            if (this.hasCoasterAttributesVisibleTarget) {
                this.CoasterAttributesVisibleTarget.disabled = true
                notInUseFields.push(this.CoasterAttributesVisibleTarget);
            }

            if (this.hasRideAttributesVisibleTarget) {
                this.RideAttributesVisibleTarget.disabled = true
                notInUseFields.push(this.RideAttributesVisibleTarget);
            }

            this.formTarget.requestSubmit();

            // Removes disabled attribute on all fields
            notInUseFields.forEach((el) => {
                el.removeAttribute('disabled');
            });
        });
    }
}